import { SendIvitationsRequest, SoggettoDto } from "@api/client";
import { praticaIdPraticaSelector } from "common/_redux/pratica/selectors";
import { subjectSendInvitation } from "common/_redux/subject/actions";
import {
	elencoTitolariEffettiviSelector,
	legaleRappresentanteSelector,
} from "common/_redux/subject/selectors";
import { getStatusTitolare, getTitolareStatusClass } from "common/helpers/common-utils";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutStepsSelector } from "layout/_redux/selectors";
import InvitoModal from "pages/onBoarding/step-3/dettagli-titolare-effettivo/invito-modal";
import { useState } from "react";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import MessageModal from "../message-modal";

const RiepilogoTitolariCard = () => {
	const dispatch = useAppDispatch();

	const location = useLocation();

	const steps = useAppSelector(layoutStepsSelector);
	const legaleRappresentante = useAppSelector(legaleRappresentanteSelector);
	const titolariEffettivi = useAppSelector(elencoTitolariEffettiviSelector);
	const idPratica = useAppSelector(praticaIdPraticaSelector);

	const currentStep = steps?.find(
		(s) => s.route == location.pathname || s?.subSteps?.find((ss) => ss?.route == location.pathname)
	);
	const stepIndex =
		steps
			?.filter((s) => !s?.hideOnMenu)
			?.findIndex(
				(s) =>
					s.route == location.pathname || s?.subSteps?.find((ss) => ss?.route == location.pathname)
			) || 0;

	const subStepIndex = currentStep?.subSteps?.findIndex((ss) => ss.route == location.pathname) || 0;

	const [showInvitationModal, setShowInvitationModal] = useState(false);
	const [showMessageModal, setShowMessageModal] = useState(false);

	const [currentTitolareReinvited, setCurrentTitolareReinvited] = useState<SoggettoDto>();

	const handleCloseInvitationModal = () => setShowInvitationModal(false);
	const handleShowInvitationModal = (titolare: SoggettoDto) => {
		setCurrentTitolareReinvited(titolare);
		setShowInvitationModal(true);
	};

	const handleCloseMessageModal = () => {
		setCurrentTitolareReinvited(undefined);
		setShowMessageModal(false);
	};
	const handleOpenMessageModal = () => setShowMessageModal(true);

	const sendInvitation = (invitationData: any) => {
		if (!idPratica) return;
		const sendInvitationRequest: SendIvitationsRequest = {
			invitationRequestDto: {
				idPratica,
				idSoggetto: invitationData.idSoggetto,
				email: invitationData.email,
				reason: invitationData.reason,
			},
		};
		dispatch(subjectSendInvitation(sendInvitationRequest))
			.unwrap()
			.then((res) => {
				if (res) {
					handleCloseInvitationModal();
					handleOpenMessageModal();
				}
			});
	};

	const isCardVisible = () => {
		if (titolariEffettivi && titolariEffettivi?.length >= 0) {
			if (stepIndex >= 3) return true;
			if (stepIndex === 2) return subStepIndex >= 4;
		}
		return false;
	};

	const getMessageOK = (nome: string | undefined, cognome: string | undefined) => {
		return (
			<>
				Non appena <span className="font-weigth-bold m-0">{`${nome} ${cognome} `}</span>
				terminerà di caricare i suoi dati, sarai avvisato a mezzo e-mail. <br />
				Ti ricordo che anche tu potrai procedere alla compilazione delle pagine dedicate al Titolare
				Effettivo collegandoti al link della mail appena ricevuta.
			</>
		);
	};

	return (
		<>
			{isCardVisible() && (
				<>
					{legaleRappresentante?.dichiarazioneDLGS != "TitolareUnico" && (
						<Card className="shadow background-gray">
							<Card.Body>
								<h5 className="m-3">Riepilogo titolari</h5>
								<div className="mx-3 mb-3">
									<div className="d-flex align-items-center mb-3" key={legaleRappresentante?.id}>
										<div className={`square-icon-shadow icon-card-v2-green`}>
											<div className="square-icon-container">
												<i className={`fas fa-user square-icon`}></i>
											</div>
										</div>

										<div className="text-left ps-2">
											<h6 className="gray m-0">
												<small>{`${legaleRappresentante?.nome?.toUpperCase()} ${legaleRappresentante?.cognome?.toUpperCase()}`}</small>
											</h6>
											<div className="d-flex">
												<span className="gray small m-0">Legale rappresentante</span>
											</div>
										</div>
									</div>
									{titolariEffettivi
										?.filter((titolare) => titolare?.tipoSoggetto != "RappresentanteLegale")
										?.map((titolare, index) => (
											<div className="d-flex align-items-center mb-3" key={`titolare_${index}`}>
												{titolare.invitationRequest ? (
													<OverlayTrigger
														key={`status-tooltip-resend${titolare.id}`}
														overlay={
															<Tooltip id={`tooltip-resend${titolare.id}`}>
																{`In attesa di compilazione`}
															</Tooltip>
														}
													>
														<div
															className={`square-icon-shadow icon-card-v2${getTitolareStatusClass(
																titolare
															)}`}
														>
															<div className="square-icon-container">
																<i className={`fas fa-user square-icon`}></i>
															</div>
														</div>
													</OverlayTrigger>
												) : (
													<div
														className={`square-icon-shadow icon-card-v2${getTitolareStatusClass(
															titolare
														)}`}
													>
														<div className="square-icon-container">
															<i className={`fas fa-user square-icon`}></i>
														</div>
													</div>
												)}

												<div className="text-left ps-2">
													<h6 className="gray m-0">
														<small>{`${titolare?.nome?.toUpperCase()} ${titolare?.cognome?.toUpperCase()}`}</small>
													</h6>
													<div className="d-flex">
														<span className="gray small m-0">{getStatusTitolare(titolare)}</span>
													</div>
												</div>
												{titolare.invitationRequest && !titolare.fullfiled && (
													<OverlayTrigger
														key={`status-tooltip-resend${titolare.id}`}
														overlay={
															<Tooltip id={`tooltip-resend${titolare.id}`}>
																{`Invia nuovo invito`}
															</Tooltip>
														}
													>
														<i
															className="fas fa-arrows-rotate resendButton ms-2 px-1"
															onClick={() => handleShowInvitationModal(titolare)}
														/>
													</OverlayTrigger>
												)}
											</div>
										))}
								</div>
							</Card.Body>
						</Card>
					)}

					<InvitoModal
						show={showInvitationModal}
						onClose={handleCloseInvitationModal}
						onConfirm={(e: any) => sendInvitation(e)}
						email={""}
						idSoggetto={currentTitolareReinvited?.id}
					/>

					<MessageModal
						show={showMessageModal}
						onClose={() => handleCloseMessageModal()}
						message={() =>
							getMessageOK(currentTitolareReinvited?.nome, currentTitolareReinvited?.cognome)
						}
						title="L'invito è stato inviato"
						centered={false}
					/>
				</>
			)}
		</>
	);
};

export default RiepilogoTitolariCard;
